<template>
  <div class="search-container">
    <div class="center-section">
      <!-- <FormKit
      type="form"
      name="searchInfoForm"
      id="searchInfoForm"
      submit-label="Submit"
      @submit="submitHandler"
      :actions="false"
      :wrapper-class="{'formkit-wrapper':false,}"
    ></FormKit> -->
      <FormKit
        id="search-type"
        type="select"
        name="searchType"
        label="Search Type"
        :options="['Email', 'Number']"
        v-model="searchType"
      />

      <FormKit
        id="search-input"
        type="text"
        :help="searchHelpMessage"
        label="Search Input"
        validation="required"
        v-model="searchInput"
      />

      <FormKit
        id="submit-button"
        type="submit"
        label="Submit"
        @click="submitHandler"
        :wrapper-class="{
          'formkit-wrapper': false,
        }"
        :input-class="{
          'formkit-input': true,
          btn: true,
        }"
      />
    </div>
  </div>
  <div class="response-message">{{ responseMessage }}</div>
  <div v-if="responseData.length > 0" class="search-response-container">
    <table id="tableComponent" class="response-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Email</th>
          <th>Title</th>
          <th>Number</th>
          <th>Seven-digit-extension</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="entry in responseData">
          <td v-for="record in entry">{{ record }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
//import AdvancedSearch from 'vue-advanced-search';
//import data from "../agents.json";
import axios from "axios";
import checkAuth from "../auth/checkAuth";

export default {
  name: "SearchAgentVM",
  data() {
    return {
      responseData: "",
      searchInput: "",
      searchType: "Email",
      responseMessage: "",
    };
  },
  computed: {
    // a computed getter
    searchHelpMessage() {
      // `this` points to the component instance
      return this.searchType === "Number"
        ? "Search by phone number need to be in (E164 format +1xxxxxxxxxx)"
        : "";
    },
  },
  methods: {
    async submitHandler() {
      try {
        checkAuth();
        console.log("Entered Search criteria logic");
        const searchCriteria = this.searchType;
        console.log(
          "searchCriteria : ",
          searchCriteria,
          ", Search Input: ",
          this.searchInput
        );

        console.log("Window Location Hostname ", window.location.hostname);
        const included = window.location.hostname.includes("cpap-int.uopx.io")
          ? true
          : false;
        console.log("Is Window Location Hostname Included? ", included);

        let postConfigBaseUrl = window.location.hostname.includes(
          "cpap-int.uopx.io"
        )
          ? "https://api.uopx.io/api/communications/voice/v1/agent"
          : "https://api.st.uopx.io/api/communications/voice/v1/agent";

        let postConfigUrl = "";

        if (searchCriteria === "Email") {
          postConfigUrl = `${postConfigBaseUrl}?email=${this.searchInput}`;
        } else if (
          searchCriteria === "Number" &&
          this.searchInput.startsWith("+1")
        ) {
          let urlEncodednumber = `%2b${this.searchInput
            .substring(1)
            .replace(/-|\s/g, "")}`; // Replacing spaces and leading +1 with %2b
          postConfigUrl = `${postConfigBaseUrl}?number=${urlEncodednumber}`;
        } else if (
          searchCriteria === "Number" &&
          !this.searchInput.startsWith("+1") &&
          this.searchInput.replace(/-|\s/g, "").length === 10
        ) {
          //If user did not enter +1 and it is 10 digit number, adding %2b1 to match phone number format
          postConfigUrl = `${postConfigBaseUrl}?number=%2b1${this.searchInput.replace(
            /-|\s/g,
            ""
          )}`;
        }
        const axiosGetConfig = {
          method: "GET",
          url: postConfigUrl,
          headers: {
            "X-Azure-Token": localStorage.getItem("jwt"),
            //"X-Azure-Token" : "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.a5WCWCgtcS5fNqICjSwKo9dv8CznjIg7cQ8U9IBfr3Wd_JrMGl7VXz7FIoQBYd7SsC_Wv6ti0JOQ6xSJIhacv_rb3z0eftIzCgkChWFr1I00wLY9KuQbkoFNl6uwNF85d0rAplCIQjeH2sj-o09kTlbBAg60gUYqXoZPlnEqAUgqNZEy4WCKwDz7RELc70XTL4AYL6eemRgJNOvo9jFEZsF5qs8hF-F6IJL6W2_LSmw0JMDPwbrPK9FQoe9esWutGyzlFo7kVorfY-LXccXiuRwHfBxI4rd4U_QnOttUMVkWtdrG2J3QMIWWkW3qRYiprekMGnyb7w2DOd4mOkQlOA",
            "Content-Type": "application/json",
          },
        };
        console.log("axiosGetConfig , ", axiosGetConfig);
        const axiosGetResponse = await axios(axiosGetConfig);
        console.log("axiosGetResponse: ", axiosGetResponse.data.agentRetrieved);
        this.responseData = axiosGetResponse.data.agentRetrieved;
        this.responseMessage = `Search for ${this.searchInput} returned ${this.responseData.length} results`;
      } catch (err) {
        console.error(err);
        this.responseMessage = err;
      }
    },
  },
};
</script>

<style scoped>
/* .search-container {
  width: 100%;
} */

.search-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

:deep(.formkit-label) {
  text-align: left;
  font-size: 16px;
}

.center-section {
  display: flex;
  flex-direction: column;
  width: 400px;
}

.response-message {
  margin-top: 20px;
  margin-bottom: 20px;
}

#tableComponent td,
#tableComponent th {
  border: 1px solid #ddd;
  padding: 8px;
}

#tableComponent tr:nth-child(even) {
  background-color: #ddd;
}

#tableComponent tr:hover {
  background-color: #31a085;
}

#tableComponent th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #2c3e50;
  color: white;
}

.response-table {
  overflow-x: auto;
}

:deep(#submit-button) {
  width: 100%;
  margin-top: 20px;
  background-color: rgb(20, 106, 210);
  margin-bottom: 20px;
}
</style>
